var _circle, _g, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDAD0C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_10764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 6H14.0002L15.3335 7.33333H18.0002C18.177 7.33333 18.3465 7.40357 18.4716 7.5286C18.5966 7.65362 18.6668 7.82319 18.6668 8V17.3333C18.6668 17.5101 18.5966 17.6797 18.4716 17.8047C18.3465 17.9298 18.177 18 18.0002 18H6.00016C5.82335 18 5.65378 17.9298 5.52876 17.8047C5.40373 17.6797 5.3335 17.5101 5.3335 17.3333V8C5.3335 7.82319 5.40373 7.65362 5.52876 7.5286C5.65378 7.40357 5.82335 7.33333 6.00016 7.33333H8.66683L10.0002 6ZM12.0002 16.6667C13.061 16.6667 14.0784 16.2452 14.8286 15.4951C15.5787 14.7449 16.0002 13.7275 16.0002 12.6667C16.0002 11.6058 15.5787 10.5884 14.8286 9.83824C14.0784 9.08809 13.061 8.66667 12.0002 8.66667C10.9393 8.66667 9.92188 9.08809 9.17174 9.83824C8.42159 10.5884 8.00016 11.6058 8.00016 12.6667C8.00016 13.7275 8.42159 14.7449 9.17174 15.4951C9.92188 16.2452 10.9393 16.6667 12.0002 16.6667V16.6667ZM12.0002 15.3333C11.2929 15.3333 10.6146 15.0524 10.1145 14.5523C9.61445 14.0522 9.3335 13.3739 9.3335 12.6667C9.3335 11.9594 9.61445 11.2811 10.1145 10.781C10.6146 10.281 11.2929 10 12.0002 10C12.7074 10 13.3857 10.281 13.8858 10.781C14.3859 11.2811 14.6668 11.9594 14.6668 12.6667C14.6668 13.3739 14.3859 14.0522 13.8858 14.5523C13.3857 15.0524 12.7074 15.3333 12.0002 15.3333Z",
    fill: "#03053D"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0498,
    cy: 12.75,
    r: 2.75,
    fill: "#3198DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_10764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8b3e8e945ece09da63d94cf98caad4bc.svg";
export { ForwardRef as ReactComponent };